<template>
  <div class="info-protect">
    <div class="bootstrap modal-content">
      <div class="modal-header">
        <h5 class="modal-title text-center">개인정보 활용동의</h5>
      </div>
      <div class="modal-body p-3">
<pre class="fs13 info-content basic-border">개인정보 수집 ‧ 이용 ‧ 제공 동의서
개인정보보호법 제 15조 법규에 의거하여 회원의 개인정보 수집 및
활용에 대해 개인정보 수집 및 활용동의서를 받고 있습니다.

개인정보 제공자가 동의한 내용 외의 다른 목적으로 활용하지 않으며, 제공된 개인정보의 이용을
거부하고자 할 때에는 개인정보 관리책임자를 통해, 열람, 정정 혹은 삭제를 요구할 수 있습니다.

[필수] 개인정보 수집 및 이용 동의
- 이용자가 제공한 모든 정보는 다음의 목적을 위해 활용하며, 하기 목적 이외의 용도로는 
사용되지 않습니다.

① 개인정보 수집 항목 및 수집·이용 목적
가) 수집 항목 (필수항목)
- 성명(국문), 전화번호(휴대전화), 이메일, 등 기재된 정보 또는 신청자가 제공한 정보
나) 수집 및 이용 목적
- 회원의 정보 관리를 위한 기본 정보 수집

② 개인정보 보유 및 이용기간
- 수집·이용 동의일로부터 개인정보의 수집·이용목적을 달성할 때까지
- 수집된 정보는 회원탈퇴 및 계정삭제 시 자동 폐기됩니다.

③ 동의거부관리
- 귀하께서는 본 안내에 따른 개인정보 수집, 이용에 대하여 동의를 거부하실 권리가
있습니다.

서비스 이용과정에서 기기정보, IP주소, 쿠키, 서비스 이용기록이 자동으로 수집될 수 있습니다.
위 동의를 거부할 권리가 있으며, 동의를 거부하실 경우 서비스 이용이 제한될 수 있습니다.</pre>
        <div class="mt-3 p-3 basic-border text-center">
          <el-checkbox v-model="checked"><span class="text-primary2 fs14">개인정보 활용에 동의합니다.</span></el-checkbox>
        </div>

      </div>
      <div class="modal-footer">
            <el-button  :disabled="!checked" type="primary" @click="$emit('close')" icon="el-icon-user">회원가입 신청</el-button>
            <el-button @click="$emit('dismiss');$router.push('/home')" icon="el-icon-house">취 소</el-button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
    data() {
      return {
        checked: false
      }
    }

}
</script>

<style scoped>
.basic-border { border: 1px solid #d7dae2; border-radius: 2; }
.info-content { padding:5px; height:250px; overflow-y: scroll; overflow-x: hidden }
</style>